import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GameAnnouncementIcon } from './GameAnnouncementIcon';
import theme from '../../styles/theme';
import { Link } from '../Link';
import { getDateLineContent } from '../../util/Dates';
import { Announcement } from 'functions/src/types/firestore/Game/Announcement';
import { OptionalWrapper } from '../OptionalWrapper';

export type GameAnnouncementProps = Pick<
  Announcement<Date>,
  'title' | 'type' | 'checkInDate' | 'date' | 'endDate' | 'href'
>;

export function GameAnnouncement({
  type,
  title,
  checkInDate,
  date,
  endDate,
  href,
}: GameAnnouncementProps) {
  if (!type || !title) {
    return null;
  }

  const dateLineContent = date
    ? getDateLineContent({
        checkInDate,
        date,
        endDate,
        type,
      })
    : 'Coming Soon';

  return (
    <OptionalWrapper
      doWrap={!!href}
      Wrapper={
        <Link
          href={href!}
          title={`Open ${type} page`}
          style={{ textDecoration: 'none' }}
        />
      }
    >
      <Box
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        pt={'8px'}
        pb={'9px'} // 1px thicker because of 1px border
        sx={{
          // Making the gradient bottom border
          background: `${theme.palette.other.outlinedBorder} left bottom no-repeat`,
          backgroundSize: '100% 1px',
          ...theme.glow.highlight,
        }}
      >
        <Box
          minWidth={40}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
          mx={1}
        >
          <GameAnnouncementIcon
            announcementType={type}
            typographyVariant={type === 'patch' ? 'h5' : 'h4'}
          />
        </Box>
        <Box
          flexGrow={1}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
        >
          <Stack spacing={0} flexGrow={1}>
            <Typography variant="body1" color={theme.palette.text.primary}>
              {title}
            </Typography>
            {!!date && !!dateLineContent && (
              <Typography variant="body2" color={theme.palette.text.secondary}>
                {dateLineContent}
              </Typography>
            )}
          </Stack>
          {/* TODO <Box display={'flex'} alignItems={'center'} sx={{ mx: 2 }}>
          <Link href="#" title={`Open ${type} page`}>
            <GradientIcon IconComponent={ArrowForwardIcon} />
          </Link>
        </Box> */}
        </Box>
      </Box>
    </OptionalWrapper>
  );
}
